import React, { useState } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { Add as PlusIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { Button } from '../ui/Button';

export type AddContentType =
  | 'objection'
  | 'faq'
  | 'landmine'
  | 'competitor'
  | 'playbook';

interface AddContentMenuProps {
  onSelect: (contentType: AddContentType) => void;
}

const CONTENT_OPTIONS: { type: AddContentType; label: string }[] = [
  { type: 'objection', label: 'Add objection' },
  { type: 'faq', label: 'Add FAQ' },
  { type: 'landmine', label: 'Add landmine' },
  { type: 'competitor', label: 'Add competitor' },
  { type: 'playbook', label: 'Add playbook' },
];

const AddContentMenu: React.FC<AddContentMenuProps> = ({ onSelect }) => {
  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);
  const isOpen = Boolean(anchorElement);

  const handleSelect = (contentType: AddContentType) => {
    setAnchorElement(null);
    onSelect(contentType);
  };

  return (
    <>
      <Button
        type="button"
        onClick={(event) => setAnchorElement(event.currentTarget)}
        aria-controls={isOpen ? 'add-content-menu' : undefined}
        aria-haspopup="menu"
        aria-expanded={isOpen ? 'true' : undefined}
      >
        <PlusIcon style={{ fontSize: '1.1rem' }} />
        Add Content
        <ExpandMoreIcon style={{ fontSize: '1.1rem' }} />
      </Button>
      <Menu
        id="add-content-menu"
        anchorEl={anchorElement}
        open={isOpen}
        onClose={() => setAnchorElement(null)}
        MenuListProps={{ 'aria-label': 'Add content options' }}
      >
        {CONTENT_OPTIONS.map((option) => (
          <MenuItem key={option.type} onClick={() => handleSelect(option.type)}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default AddContentMenu;
